module.exports = __webpack_public_path__ + "img/corporacionmedica.794350f1.png";